import React from 'react'

import { Card, Flex } from '../../../../App/Components'

import { IProps } from './IProps'
import { PerformanceGraph } from './PerformanceGraph/PerformanceGraph'
import { PersonFunction, PersonName, ProfilePicture } from './style'

export const PerformanceCard = ({
  personPerformanceData,
  firstName,
  lastName,
  profilePicture,
}: IProps) => {
  return (
    <Card>
      <Flex container>
        <Flex container flexDirection={'row'}>
          <ProfilePicture pictureLink={profilePicture} />
          <Flex container flexDirection={'column'}>
            <PersonName>{firstName}</PersonName>
            <PersonFunction>{lastName}</PersonFunction>
            <PerformanceGraph performanceStats={personPerformanceData} />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  )
}
